<po-page-default
  p-title="Processamento CAT83"
  [p-breadcrumb]="breadcrumb">

  <po-stepper #stepper>

    <!-- Step 1: Cliente -->
    <po-step p-label="Cliente" [p-can-active-next-step]="canActiveNextStepCliente">

      <po-widget
        class="po-md-12 po-pt-3"
        [p-primary-label]="nextLabelWidget"
        (p-primary-action)="beforeNextStep(0) && stepper.next()">
        <div class="po-row">
          <p class="po-font-title">Processamento digital <b class="text-green">CAT 83/2009</b></p>
        </div>
        <po-divider></po-divider>

        <div class="step-section po-mt-3">
          <div class="step-section-header">
            <i class="an an-buildings"></i>
            <span>Selecione um Cliente</span>
          </div>
          <div class="step-section-body">
            <po-combo
              name="cliente"
              [p-filter-service]="clientesServiceUrl"
              p-field-value="id"
              p-field-label="razaoSocial"
              (p-change)="chageCliente($event)"
              p-control-value-with-label="true"
              [p-required]="true"
              p-placeholder="Selecione o cliente">
            </po-combo>

            <div class="step-info-box po-mt-3">
              <i class="an an-info"></i>
              <div>
                <p>O cliente selecionado deve conter a estrutura básica de dados importados para que o processo seja possível.</p>
                <p class="po-mt-1">Caso tenha dúvidas, consulte <a href="#">Carga Inicial</a> e <a href="#">Movimentações</a> ou entre em contato com o suporte.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="step-section po-mt-3">
          <div class="step-section-header">
            <i class="an an-plus-circle"></i>
            <span>Ou cadastre um novo cliente</span>
          </div>
          <div class="step-section-body">
            <po-button p-label="Novo Cliente" p-icon="an an-user-plus" p-kind="secondary"></po-button>
          </div>
        </div>
      </po-widget>
    </po-step>

    <!-- Step 2: Período -->
    <po-step p-label="Período" [p-can-active-next-step]="canActiveNextStepPeriodo">
      <po-widget
        class="po-md-12 po-pt-3"
        [p-primary-label]="nextLabelWidget"
        [p-secondary-label]="previousLabelWidget"
        (p-primary-action)="beforeNextStep(1) && stepper.next()"
        (p-secondary-action)="stepper.previous()">

        <div class="po-row">
          <p class="po-font-title">Selecione um <b class="text-green">intervalo</b> de períodos</p>
        </div>
        <po-divider></po-divider>

        <div class="step-section po-mt-3">
          <div class="step-section-header">
            <i class="an an-calendar-blank"></i>
            <span>Período Inicial</span>
          </div>
          <div class="step-section-body">
            <div class="po-row">
              <po-select
                class="po-md-6"
                name="ano"
                [ngModel]="periodo.ano"
                (ngModelChange)="periodo.ano = $event"
                [p-options]="anos"
                p-label="Ano"
                p-required>
              </po-select>

              <po-select
                class="po-md-6"
                name="mes"
                [ngModel]="periodo.mes"
                (ngModelChange)="periodo.mes = $event"
                [p-options]="meses"
                p-label="Mês"
                p-required>
              </po-select>
            </div>
          </div>
        </div>

        <div class="step-section po-mt-2">
          <div class="step-section-header">
            <i class="an an-calendar-check"></i>
            <span>Período Final</span>
          </div>
          <div class="step-section-body">
            <div class="po-row">
              <po-select
                class="po-md-6"
                name="anoFinal"
                [ngModel]="periodoFinal.ano"
                (ngModelChange)="periodoFinal.ano = $event"
                [p-options]="anos"
                p-label="Ano"
                p-required>
              </po-select>

              <po-select
                class="po-md-6"
                name="mesFinal"
                [ngModel]="periodoFinal.mes"
                (ngModelChange)="periodoFinal.mes = $event"
                [p-options]="meses"
                p-label="Mês"
                p-required>
              </po-select>
            </div>
          </div>
        </div>

        <div class="step-info-box po-mt-3">
          <i class="an an-info"></i>
          <div>
            <p>Selecione sempre um período válido de processamento e com dados carregados no sistema.</p>
            <p class="po-mt-1">Dúvidas? Consulte <a href="#">Carga Inicial</a> e <a href="#">Movimentações</a> ou entre em contato com o suporte.</p>
          </div>
        </div>
      </po-widget>
    </po-step>

    <!-- Step 3: Checagem de dados -->
    <po-step p-label="Checagem de dados">
      <po-widget
        class="po-md-12 po-pt-3"
        [p-primary-label]="nextLabelWidget"
        [p-secondary-label]="previousLabelWidget"
        (p-primary-action)="beforeNextStep(2) && stepper.next()"
        (p-secondary-action)="stepper.previous()">
        <div class="po-row">
          <p class="po-font-title">Validação de Dados</p>
        </div>
        <po-divider></po-divider>

        <div class="validation-card po-mt-3" [ngClass]="cargaInicialOk ? 'validation-card--ok' : 'validation-card--fail'">
          <div class="validation-card-header">
            <i [class]="cargaInicialOk ? 'an an-check-circle' : 'an an-x-circle'"></i>
            <span class="validation-card-title">Validação de Carga Inicial</span>
          </div>
          @if (cargaInicialOkMessage) {
            <p class="validation-card-message">{{ cargaInicialOkMessage }}</p>
          }
        </div>

        <div class="validation-card po-mt-2" [ngClass]="movimentacaoOk ? 'validation-card--ok' : 'validation-card--fail'">
          <div class="validation-card-header">
            <i [class]="movimentacaoOk ? 'an an-check-circle' : 'an an-x-circle'"></i>
            <span class="validation-card-title">Validação de Movimentações</span>
          </div>
          @if (movimentacaoOkMessage) {
            <p class="validation-card-message">{{ movimentacaoOkMessage }}</p>
          }
        </div>

        <div class="po-mt-3">
          <p class="section-title">Máscara de Importação</p>

          <po-table
            #dynamicTable
            p-container="border"
            #wppTable
            (p-show-more)="loadMore()"
            [p-show-more-disabled]="!moreItens"
            p-striped="true"
            p-text-wrap="false"
            [p-loading-show-more]="!isHideLoading"
            [p-spacing]="poTableColumnSpacing"
            p-container="border"
            p-hide-columns-manager="true"
            [p-columns]="columns"
            [p-items]="tableItens">
          </po-table>
        </div>
      </po-widget>
    </po-step>

    <!-- Step 4: Iniciar -->
    <po-step p-label="Finalizar">
      <po-widget
        class="po-md-12 po-pt-3"
        [p-primary-label]="'Confirmar'"
        [p-secondary-label]="previousLabelWidget"
        (p-secondary-action)="stepper.previous()"
        (p-primary-action)="solicitarProcessamento()">
        <p class="po-font-title">Confira os dados do <b class="text-green">processamento.</b></p>
        <po-divider></po-divider>

        <div class="po-lg-12 po-mt-3">
          <div class="summary-banner">
            <i class="an an-check-circle"></i>
            <span>Os processos serão organizados e executados em segundo plano pelos sistemas internos.</span>
          </div>
        </div>

        <div class="po-lg-12 po-mt-3">
          <div class="summary-section">
            <div class="summary-section-header">
              <i class="an an-buildings"></i>
              <span>Cliente</span>
            </div>
            <div class="summary-grid">
              <div class="summary-field">
                <span class="summary-field-label">Razão Social</span>
                <span class="summary-field-value">({{cliente?.id}}) {{cliente?.razaoSocial}}</span>
              </div>
              <div class="summary-field">
                <span class="summary-field-label">CNPJ</span>
                <span class="summary-field-value">{{cliente?.cnpj}}</span>
              </div>
            </div>
          </div>

          <div class="summary-section">
            <div class="summary-section-header">
              <i class="an an-calendar-blank"></i>
              <span>Período de Processamento</span>
            </div>
            <div class="summary-grid">
              <div class="summary-field">
                <span class="summary-field-label">Competência Inicial</span>
                <span class="summary-field-value summary-field-value--highlight">{{periodo.mes}}/{{periodo.ano}}</span>
              </div>
              <div class="summary-field">
                <span class="summary-field-label">Competência Final</span>
                <span class="summary-field-value summary-field-value--highlight">{{periodoFinal.mes}}/{{periodoFinal.ano}}</span>
              </div>
            </div>
          </div>

          <div class="summary-section summary-section--last">
            <div class="summary-section-header">
              <i class="an an-address-book"></i>
              <span>Contato</span>
            </div>
            <div class="summary-grid">
              <div class="summary-field">
                <span class="summary-field-label">E-mail</span>
                <span class="summary-field-value">{{cliente?.email || '—'}}</span>
              </div>
              <div class="summary-field">
                <span class="summary-field-label">Telefone</span>
                <span class="summary-field-value">{{cliente?.telefone || '—'}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="po-lg-12 po-mt-3">
          <div class="summary-notes">
            <p><i class="an an-info"></i> Todas as etapas poderão ser acompanhadas na tela de listagem de processamentos.</p>
            <p><i class="an an-info"></i> Múltiplas competências serão processadas em ordem cronológica.</p>
          </div>
        </div>

        </po-widget>
      </po-step>
    </po-stepper>
  </po-page-default>

  <po-modal
    #modalProcessamento
    p-title="Processamento solicitado"
    p-ok-label="OK"
    label="Ok"
    (p-close)="onConfirmModal()">
    O processamento foi solicitado com sucesso. Ao fechar esta mensagem, você será redirecionado para a tela de listagem de processamentos.
  </po-modal>
